module.exports = __webpack_public_path__ + "static/media/1.ad98e0f3.png";